import api from './api';

export interface TipoDocumentoCobranca {
  id: string;
  nome: string;
  codigo?: number;
  especieTotvs?: string;
}

export const getAllTiposDocumentoCobranca = (contratoId: string) =>
  api.get<TipoDocumentoCobranca[]>(`tiposDocumentoCobranca/${contratoId}`);

export const getTiposDocumentoCobrancaOptions = (contratoId: string) =>
  getAllTiposDocumentoCobranca(contratoId).then(tiposDocumento =>
    (tiposDocumento || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );
